import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Quote } from '@app/core/models/quote.model';

@Injectable({
  providedIn: 'root',
})
export class QuoteService extends BaseService {
  constructor(protected http: HttpClient) {
    super('quotes', http);
  }

  getQuotesByWorkOrder(id: number): Observable<Quote[]> {
    const params = new HttpParams().set('workOrderId', id);
    return this.http.get<Quote[]>(this.resourceUrl, { params });
  }

  duplicate<T>(data: { id: number; workOrderId: number }): Observable<T> {
    return this.http.post<T>(`${this.resourceUrl}/${data.id}/duplicate`, {
      workOrderId: data.workOrderId,
    });
  }
}
